/* @flow */
import OrganizationProfileTeacher from 'entities/OrganizationProfileTeacher';
import Collection from 'lib/Collection';

class OrganizationProfileTeachers extends Collection {
  initialize() {
    this.model = OrganizationProfileTeacher;
  }
}

export default OrganizationProfileTeachers;



// WEBPACK FOOTER //
// ./src/collections/OrganizationProfileTeachers.js